var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._g(_vm._b({key:_vm.route.name,staticClass:"w-caption sidebar-link",attrs:{"to":{ name: _vm.route.name, params: _vm.route.params },"tag":"div","data-test-id":`navigation-route-${_vm.route.name}`}},'router-link',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.route.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }